import React, { useEffect, useRef, useState } from "react";
import classes from "./ReviewModal.module.css";
import classes2 from "./SearchModal.module.css";
import { toggleSearchModal } from "../Slices/searchModalSlice";
import { useAppDispatch, useAppSelector } from "../Store/hooks";
import { useAnimationControls, motion } from "framer-motion";
import BackgroundLayout from "./BackgroundLayout";
import { InputText } from "primereact/inputtext";
import SkeletonCardsGrid from "./SkeletonCardsGrid";
import MovieCard from "./Drag-Cards/MovieCard";
import {
  useGetSearchResultsMutation,
  useGetTopResultsQuery,
} from "../Slices/httpSlice";
import { toast } from "react-toastify";
import { fetchedDataType } from "./Drag-Cards/SectionDragCards";
import { useNavigate } from "react-router-dom";

const SearchModal = () => {
  const controls = useAnimationControls();
  const { searchModal } = useAppSelector((state) => state.searchModalSlice);
  const dispatch = useAppDispatch();

  const variants = {
    hidden: {
      y: window.innerHeight,
      display: "none",
    },
    visible: {
      y: 0,
      display: "block",
    },
  };

  useEffect(() => {
    if (searchModal) {
      controls.start("visible");
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [searchModal]);

  useEffect(() => {
    const updateConstraints = () => {
      setWindowWidth(window.innerWidth);
    };

    updateConstraints();
    window.addEventListener("resize", updateConstraints);

    return () => {
      window.removeEventListener("resize", updateConstraints);
    };
  }, []);

  const closeSearchModal = () => {
    controls.start("hidden");
    dispatch(toggleSearchModal());
  };

  const [topResults, setTopResults] = useState<[] | fetchedDataType[]>([]);

  const [searchResults, setSearchResults] = useState({
    movies: [],
    series: [],
    person: [],
  });

  const [pageNumber, setPageNumber] = useState<number>(1);

  const [fetchData, setFetchData] = useState<boolean>(false);

  const lastItemRef = useRef<HTMLDivElement | null>(null);

  const [inputValue, setInputValue] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);

  const [windowWidth, setWindowWidth] = useState<number>(0);

  const { data, refetch, isFetching, error } = useGetTopResultsQuery(
    {
      page: pageNumber,
    },
    {
      skip: !searchModal,
    }
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        console.log(entries[0]?.isIntersecting, "e");
        console.log(searchModal, "searchModal");
        if (entries[0]?.isIntersecting && searchModal && !fetchData) {
          console.log("enter here and fetch the data ...");
          if (pageNumber <= 16) {
            console.log("yes passed the check page number is less than 7");
            refetch();
            setFetchData(true);
          }
        }
      },
      { threshold: 1.0 }
    );

    if (lastItemRef.current) {
      observer.observe(lastItemRef.current);
    }

    return () => {
      if (lastItemRef.current) {
        observer.unobserve(lastItemRef.current);
      }
    };
  }, [pageNumber, fetchData, searchModal, lastItemRef]);

  useEffect(() => {
    if (fetchData && !isFetching) {
      console.log("enter in 1st check...");
      if (searchModal && data) {
        console.log(
          "enter here... increase pagenumber and set top results as well..."
        );
        setPageNumber((prevValue: any) => prevValue + 1);
        setTopResults((prevArray: any) => {
          return prevArray.length > 0 ? [...prevArray, data] : [data];
        });
        setFetchData(false);
      }
    }
  }, [fetchData, searchModal, data, isFetching]);

  const [searchApi, { isLoading: searchLoading }] =
    useGetSearchResultsMutation();

  console.log(fetchData, "fd");

  useEffect(() => {
    // Clear previous timeout if user is still typing
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Set a new timeout to trigger the API request after 5 seconds of no typing
    const newTimeout: any = setTimeout(() => {
      if (inputValue.trim() !== "") {
        // Call the API after 5 seconds of inactivity
        handleApiRequest();
      }
    }, 1000);

    setTypingTimeout(newTimeout);

    // Cleanup on unmount or when inputValue changes
    return () => clearTimeout(newTimeout);
  }, [inputValue]);

  const handleApiRequest = async () => {
    const response: any = await searchApi({
      body: {
        query: inputValue,
      },
    });
    console.log(response, "response....");

    if (response?.error) {
      console.log(response.error, "error");
      toast.error(
        response?.error?.data?.error?.error ||
          response?.error?.data?.error ||
          response?.error?.data ||
          response?.error?.message ||
          "Something Went Wrong!"
      );
    } else {
      setSearchResults({
        movies: response?.data?.result?.movies,
        series: response?.data?.result?.series,
        person: response?.data?.result?.person,
      });
    }
  };

  const handleInputChange = (e: any) => {
    setInputValue(e.target.value);
  };

  console.log(searchResults?.person, "p");

  const navigate = useNavigate();

  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    setStartPosition({ x: event.clientX, y: event.clientY });
    setIsDragging(false);
  };

  const handleMouseUp = (
    event: React.MouseEvent<HTMLButtonElement>,
    personId: number,
    personName: string
  ) => {
    const distance = Math.sqrt(
      Math.pow(event.clientX - startPosition.x, 2) +
        Math.pow(event.clientY - startPosition.y, 2)
    );
    if (distance < 5 && !isDragging) {
      navigate(`/person/${personId}/${personName}`);
    }
  };

  const handleMouseMove = () => {
    setIsDragging(true);
  };

  return (
    <motion.div
      className={classes.modal}
      variants={variants}
      initial="hidden"
      animate={controls}
      transition={{
        duration: 0.5,
        type: "spring",
        damping: 10,
        stiffness: 100,
      }}
    >
      <BackgroundLayout>
        <div className={classes.review_navbar}>
          <button
            className={classes.close_btn}
            type="button"
            onClick={closeSearchModal}
          >
            <i className={`pi pi-times ${classes.close_icon}`} />
          </button>
        </div>

        <div className={classes.input_form}>
          <i className={`pi pi-search ${classes.search_icon}`} />
          <InputText
            type="text"
            className={classes.search_input}
            value={inputValue}
            onChange={handleInputChange}
            placeholder="Search Movies/Series/Actors"
          />
        </div>

        <div className={classes.section_drag_cards}>
          <div className={classes.section_cards}>
            <div className={classes.category_title_container}>
              <div className={classes.title_container}>
                <p className={classes.category_title}>Top Searches</p>
              </div>
            </div>

            {searchLoading ? (
              <SkeletonCardsGrid />
            ) : (searchResults?.movies.length > 0 ||
                searchResults.series.length > 0) &&
              inputValue.trim().length !== 0 ? (
              <>
                {searchResults?.movies.length > 0 && (
                  <motion.div
                    className={classes.section_card}
                    style={{
                      gridTemplateColumns: `repeat(${searchResults?.movies.length}, 150px)`,
                    }}
                    drag="x"
                    dragConstraints={{
                      top: 0,
                      left: -(windowWidth <= 800
                        ? 10 +
                          searchResults?.movies.length * 150 +
                          searchResults?.movies.length * 10 +
                          searchResults?.movies.length * 1 -
                          windowWidth
                        : window.innerWidth * 0.05 +
                          searchResults?.movies.length * 150 +
                          searchResults?.movies.length * 10 +
                          searchResults?.movies.length * 1 -
                          windowWidth),
                      right: 0,
                      bottom: 0,
                    }}
                    transition={{
                      type: "spring",
                      damping: 100,
                      stiffness: 100,
                    }}
                  >
                    {searchResults?.movies?.map((data: any, idx: number) => {
                      return (
                        <MovieCard key={idx} data={data} navigateTo="movies" />
                      );
                    })}
                  </motion.div>
                )}

                {searchResults?.series.length > 0 && (
                  <motion.div
                    className={classes.section_card}
                    style={{
                      gridTemplateColumns: `repeat(${searchResults?.series.length}, 150px)`,
                    }}
                    drag="x"
                    dragConstraints={{
                      top: 0,
                      left: -(windowWidth <= 800
                        ? 10 +
                          searchResults?.series.length * 150 +
                          searchResults?.series.length * 10 +
                          searchResults?.series.length * 1 -
                          windowWidth
                        : window.innerWidth * 0.05 +
                          searchResults?.series.length * 150 +
                          searchResults?.series.length * 10 +
                          searchResults?.series.length * 1 -
                          windowWidth),
                      right: 0,
                      bottom: 0,
                    }}
                    transition={{
                      type: "spring",
                      damping: 100,
                      stiffness: 100,
                    }}
                  >
                    {searchResults?.series?.map((data: any, idx: number) => {
                      return (
                        <MovieCard key={idx} data={data} navigateTo="series" />
                      );
                    })}
                  </motion.div>
                )}

                {searchResults?.person.length > 0 && (
                  <motion.div
                    className={classes.section_card}
                    style={{
                      gridTemplateColumns: `repeat(${searchResults?.person.length}, 150px)`,
                    }}
                    drag="x"
                    dragConstraints={{
                      top: 0,
                      left: -(windowWidth <= 800
                        ? 10 +
                          searchResults?.person.length * 150 +
                          searchResults?.person.length * 10 +
                          searchResults?.person.length * 1 -
                          windowWidth
                        : window.innerWidth * 0.05 +
                          searchResults?.person.length * 150 +
                          searchResults?.person.length * 10 +
                          searchResults?.person.length * 1 -
                          windowWidth),
                      right: 0,
                      bottom: 0,
                    }}
                    transition={{
                      type: "spring",
                      damping: 100,
                      stiffness: 100,
                    }}
                  >
                    {searchResults?.person?.map(
                      (dataItem: any, idx: number) => {
                        return (
                          <button
                            type="button"
                            className={classes2.cast_image_card}
                            key={idx}
                            onMouseDown={(event) => handleMouseDown(event)}
                            onMouseUp={(event) =>
                              handleMouseUp(
                                event,
                                dataItem?.id,
                                dataItem?.name ?? dataItem?.original_name
                              )
                            }
                            onMouseMove={handleMouseMove}
                          >
                            <div className={classes2.cast_image}>
                              {dataItem?.profile_path ? (
                                <img
                                  src={`${process.env.REACT_APP_MEDIA_PATH_PREFIX?.replace(
                                    "<replace_media_id>",
                                    dataItem?.profile_path
                                  )}`}
                                  alt="movie photos"
                                  className={classes2.cast_img}
                                  onError={(e: any) =>
                                    (e.target.src =
                                      "/assets/images/avatar-image-not-found.png")
                                  }
                                />
                              ) : (
                                <img
                                  src="/assets/images/avatar-image-not-found.png"
                                  alt="movie photos"
                                  className={classes2.cast_img}
                                  onError={(e: any) =>
                                    (e.target.src =
                                      "/assets/images/avatar-image-not-found.png")
                                  }
                                />
                              )}
                            </div>

                            <div className={classes2.cast_card_content}>
                              <p className={classes2.original_name}>
                                {dataItem?.name ?? dataItem?.original_name}
                              </p>
                            </div>
                          </button>
                          // <MovieCard key={idx} data={data} navigateTo="series" />
                        );
                      }
                    )}
                  </motion.div>
                )}
              </>
            ) : (
              <>
                {topResults?.map((data: any, idx: number) => {
                  console.log(data, "d");
                  return (
                    <motion.div
                      key={idx}
                      className={classes.section_card}
                      style={{
                        gridTemplateColumns: `repeat(${topResults[idx]?.result?.results?.length}, 150px)`,
                      }}
                      drag="x"
                      dragConstraints={{
                        top: 0,
                        left: -(windowWidth <= 800
                          ? 10 +
                            topResults[idx]?.result?.results.length * 150 +
                            topResults[idx]?.result?.results.length * 10 +
                            topResults[idx]?.result?.results.length * 1 -
                            windowWidth
                          : window.innerWidth * 0.05 +
                            topResults[idx]?.result?.results.length * 150 +
                            topResults[idx]?.result?.results.length * 10 +
                            topResults[idx]?.result?.results.length * 1 -
                            windowWidth),
                        right: 0,
                        bottom: 0,
                      }}
                      transition={{
                        type: "spring",
                        damping: 100,
                        stiffness: 100,
                      }}
                    >
                      {data?.result?.results?.map(
                        (dataItem: any, idx2: number) => (
                          <MovieCard
                            key={`${idx}-${idx2}`}
                            data={dataItem}
                            navigateTo={
                              dataItem?.media_type === "tv"
                                ? "series"
                                : "movies"
                            }
                          />
                        )
                      )}
                    </motion.div>
                  );
                })}

                {isFetching && <SkeletonCardsGrid />}
              </>
            )}

            {pageNumber >= 16 ? null : (
              <div ref={lastItemRef} className={classes.load_item}></div>
            )}
          </div>
        </div>
      </BackgroundLayout>
    </motion.div>
  );
};

export default SearchModal;
